export default __webpack_public_path__ + "static/media/nmig_site.26401d82.svg";